import React, { Component } from 'react'
import { Container, Segment, Header, Button, Message } from 'semantic-ui-react'
import numeral from 'numeral'
import moment from 'moment'
class ReservationReview extends Component {
    render() {
        const { event, selectedFacility, spots, status, blocks, parker, additionalInfo, onEdit, onSubmit, confirmation, passedInventory, error, loading } = this.props
        const inventory = passedInventory || event.inventory.find((i) => i.id === selectedFacility.inventoryId)
        // const { token } = parker
        const startDate = blocks.sort((a, b) => {
            var aDt = moment(a.startDate)
            var bDt = moment(b.startDate)
            if (aDt > bDt) return 1
            if (aDt < bDt) return -1
            return 0
        })[0].startDate
        const additionalFields = event && event.additionalFields ? JSON.parse(event.additionalFields) : {}
        console.log('status', status)
        return (
            <Container>
                <Header className="page title" as="h1" content={`Welcome ${event.name}`} />
                <Header as="h3" content={confirmation ? `Reservation Confirmation: ${confirmation}` : '... Review your reservation details before submitting'} />
                {confirmation && status !== 0 ? (
                    <Segment>
                        <Header as="h1" content={`You’re all set!`} />
                        <Header as="h1" content={`A confirmation email and receipt has been sent to ${parker.email}.`} />
                        <Header as="h2" content={`See you on ${moment(startDate).format('L')}!`} />
                        <Header
                            as="h2"
                            content={`If you have any questions or need to make any changes to your reservation contact ${selectedFacility.manager.firstName} ${
                                selectedFacility.manager.lastName
                            } at ${selectedFacility.manager.phone || selectedFacility.manager.email}.`}
                        />
                        <Button primary content="Continue" onClick={() => (window.location = window.location.pathname.replace('/review', ''))} />
                    </Segment>
                ) : null}
                <Segment>
                    {error ? <Message error content={error} /> : null}
                    <Header as="h4" content="Reservation Details" />
                    <div className="selected parking">
                        {blocks.map((block) => (
                            <div>
                                <div>{`${block.name} - ${spots} ${spots > 1 ? 'spots' : 'spot'} @ ${numeral(
                                    inventory.blocks.find((ib) => ib.eventBlockId === block.id).rate
                                ).format('$0,0.00')} each`}</div>
                            </div>
                        ))}
                    </div>
                    <div>
                        <strong>Total to be charged:</strong>{' '}
                        {`${numeral(blocks.reduce((acc, cur) => acc + spots * inventory.blocks.find((ib) => ib.eventBlockId === cur.id).rate, 0)).format('$0,0.00')}`}
                    </div>
                    <Header as="h4" content="Facility Details" />
                    <div className="selected facility">
                        <div>
                            {selectedFacility.name} {selectedFacility.address}
                        </div>
                        <div>Type: {selectedFacility.isLot ? 'Lot' : `Garage - ${selectedFacility.clearanceFeet}'${selectedFacility.clearanceInches}''`}</div>
                    </div>
                    <Header as="h4" content="Parker Details" />
                    <div>
                        <div>{parker.name}</div>
                        <div>{`${parker.address},${parker.address2 ? ' ' + parker.address2 + ',' : ''} ${parker.city}, ${parker.state} ${parker.zip}`}</div>
                        <div>{parker.mobile}</div>
                        <div>{parker.email}</div>
                    </div>
                    {Object.keys(additionalFields).length > 0 ? <Header as="h4" content="Additional Information" /> : null}
                    {Object.keys(additionalFields).length > 0 ? (
                        <div>
                            {Object.keys(additionalFields).map((f) => (
                                <div>{additionalInfo[additionalFields[f].name]}</div>
                            ))}
                        </div>
                    ) : null}
                    {/* <Header as="h4" content="Credit Card Information" />
                    <div>
                        <div>{`${token.card.brand} - ${token.card.last4}`}</div>
                        <div>{`Expires ${token.card.exp_month} / ${token.card.exp_year}`}</div>
                    </div> */}
                </Segment>
                {/* {!confirmation ? <Button content="Edit" onClick={onEdit} disabled={loading} /> : null}{' '}
                {!confirmation ? <Button loading={loading} disabled={loading} primary content="Go to Payment" onClick={onSubmit} /> : null} */}
                {onEdit && <Button content="Edit" onClick={onEdit} disabled={loading} />}
                {onSubmit && <Button loading={loading} disabled={loading} primary content="Go to Payment" onClick={onSubmit} />}
            </Container>
        )
    }
}

ReservationReview.propTypes = {}

export default ReservationReview
